import React, { useState } from 'react';
import { IPaymentPromo } from './types';
import style from './style.module.scss';
import { TextField, Button } from '@material-ui/core';
import { wrapperStyleType } from 'shared-types/index';
import classNames from 'classnames';

const NS = 'PaymentPromo';

export default function PaymentPromo({ handleApply, promotionCode, errorMessage, wrapperStyle}: IPaymentPromo) {

  const [textVal, setTextVal] = useState<string>(promotionCode);

  const isTightFit = wrapperStyle === wrapperStyleType.standard;

  return (
    <div className={classNames({
      [style.root]: true,
      [style.rootIsTightFit]: isTightFit
    })}>

      <TextField
        className={classNames({
          [style.text]: true,
          [style.textIsTightFit]: isTightFit
        })}
        label="Promotion Code:"
        onChange={(evt) => setTextVal(evt.target.value)}
        error={!!errorMessage}
        helperText={errorMessage || ''}
      />
      <div className={classNames({
        [style.btnWrap]: true,
        [style.btnWrapIsTightFit]: isTightFit
      })}>
        <Button
          variant="contained" color="secondary" size="small"
          disabled={!textVal}
          onClick={() => handleApply(textVal)}>
          Apply Discount
      </Button>
      </div>
    </div>
  )
}
